import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { COMMUNITY_APP_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const CommunityAppService = ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_APP_RESOURCE,
      method: 'get',
      request: (id, rejectCallback, t) => ({
        url: apiRoutes.communityApps(id),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getAppFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CommunityAppService;
